import { LDPluginOptions } from 'launchdarkly-vue-client-sdk';

export const getLDConfig = async (): Promise<LDPluginOptions> => {
  const config: LDPluginOptions = {};

  // Add the client side ID which is required
  const clientSideID = import.meta.env.VITE_APP_FEATURE_FLAGS_CLIENT_SIDE_ID;

  if (typeof clientSideID !== 'string' || clientSideID.trim() === '') {
    console.error(
      '[LaunchDarkly] Missing or invalid client side ID. Please ensure this environment variable is defined and non-empty.',
    );
  }

  config.clientSideID = clientSideID;

  // Add the local flags if they are enabled
  if (import.meta.env.VITE_APP_USE_LOCAL_FLAGS === 'true') {
    try {
      console.info('[LaunchDarkly] Loading local flags from flags.local.json');

      const localFlagsModule = await import('../../../../flags.local.json');
      const localFlagsJson = localFlagsModule.default as Record<string, unknown>;

      console.info('[LaunchDarkly] Local flags loaded successfully');

      // When using local flags, disable streaming and events and bootstrap with local data
      config.streaming = false;
      config.options = {
        ...(config.options ?? {}),
        bootstrap: localFlagsJson,
        streaming: false,
        sendEvents: false,
        fetchGoals: false,
        useReport: false,
      };
    } catch (error) {
      console.error('[LaunchDarkly] Failed to load local flags from flags.local.json', error);
    }
  }

  return config;
};
